import * as types from './types';
import * as vehicleActions from 'services/api/vehicles';
import * as invoiceItemAPI from 'services/api/invoiceItem';
import { getErrorMessage, parsePagination, removeEmpty, isCancel } from 'utils';
import { uiActions } from 'state/modules/UI';
import i18n from 'i18n-js';
import * as organizationActions from 'services/api/organizations';

// Get vehicles
const fetchVehiclesRequest = () => ({
  type: types.FETCH_VEHICLES_REQUEST,
});

const fetchVehiclesSuccess = (payload) => ({
  type: types.FETCH_VEHICLES_SUCCESS,
  payload,
});

const fetchVehiclesFailed = () => ({
  type: types.FETCH_VEHICLES_FAILED,
});

export const fetchVehicles = (params = {}, options = {}, queryFields) => {
  return async (dispatch) => {
    dispatch(fetchVehiclesRequest());

    params = removeEmpty(params);

    const { invoice_item_id, rest } = params;

    let response;

    if (invoice_item_id) {
      response = await invoiceItemAPI.fetchInvoicesItemVehicles(invoice_item_id, rest, options);
    } else {
      response = await vehicleActions.fetchVehicles(params, options, queryFields);
    }

    if (response.ok) {
      const pagination = parsePagination(response.headers);
      return dispatch(
        fetchVehiclesSuccess({
          pagination: pagination,
          data: response.data,
        })
      );
    }

    if (!isCancel(response)) {
      const error = getErrorMessage(response.data);

      dispatch(
        uiActions.handleShowSnackbar({
          type: 'error',
          message: error,
        })
      );

      dispatch(fetchVehiclesFailed(error));
    }
  };
};

/*
  RESET VEHICLES
 */

const resetVehiclesSuccess = () => ({
  type: types.RESET_VEHICLES_SUCCESS,
});

export const resetVehicles = () => {
  return async (dispatch) => {
    dispatch(resetVehiclesSuccess());
  };
};

// Get vehicle by ID
const fetchVehicleByIdRequest = () => ({
  type: types.FETCH_VEHICLE_BY_ID_REQUEST,
});

const fetchVehicleByIdSuccess = (payload, page = 'details') => ({
  type: types.FETCH_VEHICLE_BY_ID_SUCCESS,
  payload,
  page,
});

const fetchVehicleByIdFailed = (error) => ({
  type: types.FETCH_VEHICLE_BY_ID_FAILED,
  error,
});

export const fetchVehicleById = (id, page = 'details', list) => {
  return async (dispatch) => {
    if (id == null || id === 'undefined') return;
    dispatch(fetchVehicleByIdRequest());
    const response = await vehicleActions.fetchVehicleById(id);
    if (response.ok) {
      if (list) {
        return dispatch(
          fetchVehiclesSuccess({
            pagination: {},
            data: [response.data],
          })
        );
      }
      return dispatch(fetchVehicleByIdSuccess(response.data, page));
    }
    const errorMessage = getErrorMessage(response.data);
    dispatch(
      uiActions.handleShowSnackbar({
        type: 'error',
        message: errorMessage,
      })
    );
    dispatch(
      fetchVehicleByIdFailed({ type: response.data?.key || 'ERROR', message: errorMessage })
    );
  };
};

// Get vehicle by ID
const fetchVehicleOrgsByIdRequest = () => ({
  type: types.FETCH_VEHICLE_ORGS_BY_ID_REQUEST,
});

const fetchVehicleOrgsByIdSuccess = (payload, page = 'details') => ({
  type: types.FETCH_VEHICLE_ORGS_BY_ID_SUCCESS,
  payload,
  page,
});

const fetchVehicleOrgsByIdFailed = () => ({
  type: types.FETCH_VEHICLE_ORGS_BY_ID_FAILED,
});

export const fetchVehicleOrgsById = (id) => {
  return async (dispatch) => {
    dispatch(fetchVehicleOrgsByIdRequest());
    const response = await vehicleActions.fetchVehicleOrgsById(id);
    if (response.ok) {
      return dispatch(fetchVehicleOrgsByIdSuccess(response.data));
    }
    const error = getErrorMessage(response.data);
    dispatch(
      uiActions.handleShowSnackbar({
        type: 'error',
        message: error,
      })
    );
    dispatch(fetchVehicleOrgsByIdFailed(error));
  };
};

// Get vehicle by ID
const fetchDeleteVehicleRequest = () => ({
  type: types.FETCH_DELETE_VEHICLE_REQUEST,
});

const fetchDeleteVehicleSuccess = (payload) => ({
  type: types.FETCH_DELETE_VEHICLE_SUCCESS,
  payload,
});

const fetchDeleteVehicleFailed = () => ({
  type: types.FETCH_DELETE_VEHICLE_FAILED,
});

export const fetchDeleteVehicle = (id) => {
  return async (dispatch) => {
    dispatch(fetchDeleteVehicleRequest());

    const response = await vehicleActions.deleteVehicle(id);

    if (response.ok) {
      dispatch(
        uiActions.handleShowSnackbar({
          type: 'success',
          message: i18n.t('vehicle.delete_success_msg'),
        })
      );
      return dispatch(fetchDeleteVehicleSuccess(response.data));
    }

    const error = getErrorMessage(response.data);

    dispatch(
      uiActions.handleShowSnackbar({
        type: 'error',
        message: error,
      })
    );

    dispatch(fetchDeleteVehicleFailed(error));
  };
};

/* 
  RESET DELETE VEHICLE
 */
const resetDeleteVehicleSuccess = (payload) => ({
  type: types.RESET_DELETE_VEHICLE_SUCCESS,
  payload,
});
export const resetDeleteVehicle = () => {
  return async (dispatch) => {
    dispatch(resetDeleteVehicleSuccess());
  };
};

// Get vehicles asset classes
const fetchVehiclesAssetClassesRequest = () => ({
  type: types.FETCH_VEHICLES_ASSET_CLASSES_REQUEST,
});

const fetchVehiclesAssetClassesSuccess = (payload) => ({
  type: types.FETCH_VEHICLES_ASSET_CLASSES_SUCCESS,
  payload,
});

const fetchVehiclesAssetClassesFailed = () => ({
  type: types.FETCH_VEHICLES_ASSET_CLASSES_FAILED,
});

export const fetchVehiclesAssetClasses = (params) => {
  return async (dispatch) => {
    dispatch(fetchVehiclesAssetClassesRequest());

    const response = await vehicleActions.fetchVehiclesAssetClasses(params);

    if (response.ok) {
      return dispatch(fetchVehiclesAssetClassesSuccess(response.data?.asset_classes));
    }

    const error = getErrorMessage(response.data);

    dispatch(
      uiActions.handleShowSnackbar({
        type: 'error',
        message: error,
      })
    );

    dispatch(fetchVehiclesAssetClassesFailed(error));
  };
};
// Get vehicles types
const fetchVehiclesTypesRequest = () => ({
  type: types.FETCH_VEHICLES_TYPES_REQUEST,
});

const fetchVehiclesTypesSuccess = (payload) => ({
  type: types.FETCH_VEHICLES_TYPES_SUCCESS,
  payload,
});

const fetchVehiclesTypesFailed = () => ({
  type: types.FETCH_VEHICLES_TYPES_FAILED,
});

export const fetchVehiclesTypes = (params, options) => {
  return async (dispatch) => {
    dispatch(fetchVehiclesTypesRequest());

    let response;

    if (params?.id) response = await vehicleActions.fetchVehicleTypeById(params.id);
    else response = await vehicleActions.fetchVehiclesTypes(params, options);

    if (response.ok) {
      const pagination = parsePagination(response.headers);
      return dispatch(
        fetchVehiclesTypesSuccess({
          pagination: pagination,
          data: Array.isArray(response.data) ? response.data : [response.data],
        })
      );
    }

    if (!isCancel(response)) {
      const error = getErrorMessage(response.data);

      dispatch(
        uiActions.handleShowSnackbar({
          type: 'error',
          message: error,
        })
      );

      dispatch(fetchVehiclesTypesFailed(error));
    }
  };
};
// Reset vehicles types
const resetVehiclesTypesSuccess = (payload) => ({
  type: types.RESET_VEHICLES_TYPES_SUCCESS,
  payload,
});

export const resetVehiclesTypes = () => {
  return async (dispatch) => {
    dispatch(resetVehiclesTypesSuccess());
  };
};

// Get vehicle by ID
const fetchVehicleTypeByIdRequest = () => ({
  type: types.FETCH_VEHICLE_TYPE_BY_ID_REQUEST,
});

const fetchVehicleTypeByIdSuccess = (payload) => ({
  type: types.FETCH_VEHICLE_TYPE_BY_ID_SUCCESS,
  payload,
});

const fetchVehicleTypeByIdFailed = (payload) => ({
  type: types.FETCH_VEHICLE_TYPE_BY_ID_FAILED,
  payload,
});

export const fetchVehicleTypeById = (id) => {
  return async (dispatch) => {
    dispatch(fetchVehicleTypeByIdRequest());

    const response = await vehicleActions.fetchVehicleTypeById(id);

    if (response.ok) {
      return dispatch(fetchVehicleTypeByIdSuccess(response.data));
    }

    const error = getErrorMessage(response.data);

    dispatch(
      uiActions.handleShowSnackbar({
        type: 'error',
        message: error,
      })
    );

    dispatch(fetchVehicleTypeByIdFailed(error));
  };
};

// Get vehicle type categoCategories
const fetchVehicleTypeCategoriesRequest = () => ({
  type: types.FETCH_VEHICLE_TYPE_CATEGORIES_REQUEST,
});

const fetchVehicleTypeCategoriesSuccess = (payload) => ({
  type: types.FETCH_VEHICLE_TYPE_CATEGORIES_SUCCESS,
  payload,
});

const fetchVehicleTypeCategoriesFailed = (payload) => ({
  type: types.FETCH_VEHICLE_TYPE_CATEGORIES_FAILED,
  payload,
});

export const fetchVehicleTypeCategories = (params) => {
  return async (dispatch) => {
    dispatch(fetchVehicleTypeCategoriesRequest());

    const response = await vehicleActions.fetchVehicleTypeCategories(params);

    if (response.ok) {
      return dispatch(
        fetchVehicleTypeCategoriesSuccess({
          data: response.data,
        })
      );
    }

    const error = getErrorMessage(response.data);

    dispatch(
      uiActions.handleShowSnackbar({
        type: 'error',
        message: error,
      })
    );

    dispatch(fetchVehicleTypeCategoriesFailed(error));
  };
};

// Reset vehicles types
const resetVehiclesTypeCategoriesSuccess = (payload) => ({
  type: types.RESET_VEHICLES_TYPE_CATEGORIES_SUCCESS,
  payload,
});

export const resetVehiclesTypeCategories = () => {
  return async (dispatch) => {
    dispatch(resetVehiclesTypeCategoriesSuccess());
  };
};

// Create vehicles types
const createVehicleTypeRequest = () => ({
  type: types.CREATE_VEHICLE_TYPE_REQUEST,
});

const createVehicleTypeSuccess = (payload) => ({
  type: types.CREATE_VEHICLE_TYPE_SUCCESS,
  payload,
});

const createVehicleTypeFailed = (payload) => ({
  type: types.CREATE_VEHICLE_TYPE_FAILED,
  payload,
});

export const createVehicleType = (params) => {
  return async (dispatch) => {
    dispatch(createVehicleTypeRequest());

    const response = await vehicleActions.createVehicleType(params);

    if (response.ok) {
      return dispatch(createVehicleTypeSuccess(response.data));
    }

    const formattedError = getErrorMessage(response.data);

    if (typeof formattedError === 'string') {
      dispatch(createVehicleTypeFailed());

      return dispatch(
        uiActions.handleShowSnackbar({
          type: 'error',
          message: formattedError,
        })
      );
    }

    let errors = {};

    formattedError?.length &&
      formattedError.map((val) => {
        return (errors[val.field] = val.message);
      });

    dispatch(createVehicleTypeFailed({ errors }));
  };
};

// Update vehicles types
const updateVehicleTypeRequest = () => ({
  type: types.UPDATE_VEHICLE_TYPE_REQUEST,
});

const updateVehicleTypeSuccess = (payload) => ({
  type: types.UPDATE_VEHICLE_TYPE_SUCCESS,
  payload,
});

const updateVehicleTypeFailed = (payload) => ({
  type: types.UPDATE_VEHICLE_TYPE_FAILED,
  payload,
});

export const updateVehicleType = (id, params) => {
  return async (dispatch) => {
    dispatch(updateVehicleTypeRequest());

    const response = await vehicleActions.updateVehicleType(id, params);

    if (response.ok) {
      return dispatch(updateVehicleTypeSuccess(response.data));
    }

    const formattedError = getErrorMessage(response.data, {}, true);
    if (typeof formattedError === 'string') {
      dispatch(updateVehicleTypeFailed());

      return dispatch(
        uiActions.handleShowSnackbar({
          type: 'error',
          message: formattedError,
        })
      );
    }

    let errors = {};

    formattedError?.length &&
      formattedError.map((val) => {
        return (errors[val.field] = val.message);
      });

    dispatch(updateVehicleTypeFailed({ errors }));
  };
};

// Reset vehicle typeonboarding
export const resetVehicleTypeOnboarding = () => (dispatch) => {
  return dispatch({ type: types.RESET_VEHICLE_TYPE_ONBOARDING });
};

// Onboarding
const onExit = (payload) => ({
  type: types.SET_EXIT,
  payload,
});

export const setExit = (exit, type) => (dispatch) => {
  return dispatch(onExit({ exit, type }));
};

const onNextPosition = (payload) => ({
  type: types.CHANGE_POSITION,
  payload,
});

export const changePosition = (type, exit) => (dispatch, getState) => {
  if (exit) {
    return dispatch(setExit(exit, 'exitOnboarding'));
  }

  const {
    onboarding: { position },
  } = getState().vehicles;

  const nextPosition = type === 'next' ? 1 : -1;

  return dispatch(onNextPosition({ position: position + nextPosition }));
};

export const changeStep = (step) => (dispatch, getState) => {
  const {
    onboarding: { position },
  } = getState().vehicles;

  let nextPosition;

  switch (step) {
    case 'details':
      nextPosition = 0;
      break;
    case 'connection':
      nextPosition = 1;
      break;
    case 'services':
      nextPosition = 2;
      break;
    default:
      nextPosition = position;
  }

  return dispatch(onNextPosition({ position: position + nextPosition }));
};

// Reset onboarding
export const resetOnboarding = () => (dispatch) => {
  return dispatch({ type: types.RESET_ONBOARDING });
};
// Create vehicle
const fetchCreateVehicleRequest = () => ({
  type: types.FETCH_CREATE_VEHICLE_REQUEST,
});

const fetchCreateVehicleSuccess = (payload) => ({
  type: types.FETCH_CREATE_VEHICLE_SUCCESS,
  payload,
});

const fetchCreateVehicleFailed = (payload) => ({
  type: types.FETCH_CREATE_VEHICLE_FAILED,
  payload,
});

export const fetchCreateVehicle = (payload, step, exit) => async (dispatch, getState) => {
  const {
    onboarding: { steps },
  } = getState().vehicles;
  dispatch(fetchCreateVehicleRequest());

  let response, responseVG;
  if (steps?.details?.id) {
    response = await vehicleActions.updateVehicle(steps.details.id, payload);
  } else {
    response = await vehicleActions.createVehicle(payload);
  }

  if (response.ok && (!steps?.details?.id || !payload.vehicle_group_id)) {
    dispatch(
      fetchCreateVehicleSuccess({
        data: response.data,
        step,
      })
    );
    return dispatch(changePosition('next', exit));
  }
  // if the service group was changed call another request
  else if (response.ok && steps?.details?.id) {
    responseVG = await vehicleActions.changeVehicleGroup(steps.details.id, {
      group_id: payload.vehicle_group_id,
    });
    if (responseVG.ok) {
      dispatch(
        fetchCreateVehicleSuccess({
          data: responseVG.data,
          step,
        })
      );
      return dispatch(changePosition('next', exit));
    }
  }

  const formattedError = getErrorMessage(responseVG?.data || response?.data, {}, true);

  if (typeof formattedError === 'string') {
    dispatch(fetchCreateVehicleFailed());

    return dispatch(
      uiActions.handleShowSnackbar({
        type: 'error',
        message: formattedError,
      })
    );
  }

  let errors = {};

  formattedError?.length &&
    formattedError.map((val) => {
      return (errors[val.field] = val.message);
    });

  dispatch(fetchCreateVehicleFailed({ errors }));
};

// edit vehicle
const updateVehicleRequest = () => ({
  type: types.UPDATE_VEHICLE_REQUEST,
});

const updateVehicleSuccess = (payload) => ({
  type: types.UPDATE_VEHICLE_SUCCESS,
  payload,
});

const updateVehicleFailed = (payload) => ({
  type: types.UPDATE_VEHICLE_FAILED,
  payload,
});

//TODO rename on refactor the wizard component
export const updateVehicle = (vehicle_id, payload) => async (dispatch) => {
  dispatch(updateVehicleRequest());

  const response = await vehicleActions.updateVehicle(vehicle_id, payload);
  if (response.ok) {
    dispatch(
      uiActions.handleShowSnackbar({
        type: 'success',
        message: i18n.t('vehicle.edited_success_msg'),
      })
    );
    dispatch(
      updateVehicleSuccess({
        data: response.data,
      })
    );
    return response;
  }

  const formattedError = getErrorMessage(response.data);

  if (typeof formattedError === 'string') {
    dispatch(updateVehicleFailed(formattedError));

    dispatch(
      uiActions.handleShowSnackbar({
        type: 'error',
        message: formattedError,
      })
    );
    return response;
  }

  let errors = {};

  formattedError?.length &&
    formattedError.map((val) => {
      return (errors[val.field] = val.message);
    });

  dispatch(updateVehicleGroupFailed({ errors }));
};
// end edit vehicle

const updateStepListsRequest = (payload) => ({
  type: types.UPDATE_STEPS_LISTS_REQUEST,
  payload,
});

const updateStepListsSuccess = (payload) => ({
  type: types.UPDATE_STEPS_LISTS_SUCCESS,
  payload,
});

const updateStepListsFailed = (payload) => ({
  type: types.UPDATE_STEPS_LISTS_FAILED,
  payload,
});

const fetchAddItemToVehiclesRequest = (payload) => ({
  type: types.FETCH_ADD_SERVICES_TO_VEHICLES_REQUEST,
  payload,
});

const fetchAddItemToVehiclesSuccess = (payload) => ({
  type: types.FETCH_ADD_SERVICES_TO_VEHICLES_SUCCESS,
  payload,
});

const fetchAddItemToVehiclesFailed = (payload) => ({
  type: types.FETCH_ADD_SERVICES_TO_VEHICLES_FAILED,
  payload,
});

export const fetchAddServicesToVehicles = (id, payload) => async (dispatch) => {
  dispatch(fetchAddItemToVehiclesRequest());

  const response = await vehicleActions.addServiceToVehicle(id, payload);

  if (response.ok) {
    dispatch(
      uiActions.handleShowSnackbar({
        type: 'success',
        message: 'Service added successfully to vehicle',
      })
    );
    return dispatch(
      fetchAddItemToVehiclesSuccess({
        step: 'details',
        data: response.data,
      })
    );
  }

  const formattedError = getErrorMessage(response.data);

  if (typeof formattedError === 'string') {
    dispatch(
      uiActions.handleShowSnackbar({
        type: 'error',
        message: formattedError,
      })
    );
  }

  dispatch(fetchAddItemToVehiclesFailed({ errors: formattedError }));
};

const fetchRemoveItemToVehiclesRequest = (payload) => ({
  type: types.FETCH_REMOVE_SERVICES_TO_VEHICLES_REQUEST,
  payload,
});

const fetchRemoveItemToVehiclesSuccess = (payload) => ({
  type: types.FETCH_REMOVE_SERVICES_TO_VEHICLES_SUCCESS,
  payload,
});

const fetchRemoveItemToVehiclesFailed = (payload) => ({
  type: types.FETCH_REMOVE_SERVICES_TO_VEHICLES_FAILED,
  payload,
});

export const fetchRemoveServicesToVehicles = (id, payload) => async (dispatch) => {
  dispatch(fetchRemoveItemToVehiclesRequest());

  const response = await vehicleActions.removeServiceToVehicle(id, payload);

  if (response.ok) {
    dispatch(
      uiActions.handleShowSnackbar({
        type: 'success',
        message: i18n.t(`vehicle.service_removed_successfully`),
      })
    );
    return dispatch(
      fetchRemoveItemToVehiclesSuccess({
        step: 'details',
        data: payload,
      })
    );
  }

  const formattedError = getErrorMessage(response.data);

  if (typeof formattedError === 'string') {
    dispatch(
      uiActions.handleShowSnackbar({
        type: 'error',
        message: formattedError,
      })
    );
  }

  dispatch(fetchRemoveItemToVehiclesFailed({ errors: formattedError }));
};

const fetchVehicleBrokersRequest = (payload) => ({
  type: types.FETCH_VEHICLE_BROKERS_REQUEST,
  payload,
});

const fetchVehicleBrokersSuccess = (payload) => ({
  type: types.FETCH_VEHICLE_BROKERS_SUCCESS,
  payload,
});

const fetchVehicleBrokersFailed = (payload) => ({
  type: types.FETCH_VEHICLE_BROKERS_FAILED,
  payload,
});

export const fetchVehicleBrokers = (id, step) => async (dispatch) => {
  dispatch(fetchVehicleBrokersRequest());

  const response = await vehicleActions.getBrokers(id);

  if (response.ok) {
    return dispatch(
      fetchVehicleBrokersSuccess({
        step,
        data: response.data,
      })
    );
  }

  const formattedError = getErrorMessage(response.data);

  dispatch(fetchVehicleBrokersFailed({ errors: formattedError }));

  if (typeof formattedError === 'string') {
    return dispatch(
      uiActions.handleShowSnackbar({
        type: 'error',
        message: formattedError,
      })
    );
  }

  dispatch(
    uiActions.handleShowSnackbar({
      type: 'error',
      message: formattedError[0].message,
    })
  );
};

const fetchAddBrokerRequest = (payload) => ({
  type: types.FETCH_ADD_BROKER_REQUEST,
  payload,
});

const fetchAddBrokerSuccess = (payload) => ({
  type: types.FETCH_ADD_BROKER_SUCCESS,
  payload,
});

const fetchAddBrokerFailed = (payload) => ({
  type: types.FETCH_ADD_BROKER_FAILED,
  payload,
});

export const fetchAddBroker = (id, payload, action) => async (dispatch) => {
  dispatch(fetchAddBrokerRequest());

  const response = await vehicleActions.addBroker(id, payload);

  if (response.ok) {
    dispatch(
      uiActions.handleShowSnackbar({
        type: 'success',
        message: i18n.t('brokers.added_successfully'),
      })
    );
    if (action) action();
    dispatch(fetchAddBrokerSuccess(response.data));
    return dispatch(fetchVehicleById(id, 'onboarding'));
  }

  const formattedError = getErrorMessage(response.data);
  const errorsDetails = response?.data?.details || [];
  const errors = {};

  dispatch(
    uiActions.handleShowSnackbar({
      type: 'error',
      message: formattedError,
    })
  );

  errorsDetails?.length > 0 &&
    errorsDetails?.map((val) => {
      return (errors[val.field] = val.message);
    });

  dispatch(fetchAddBrokerFailed({ errors }));
};

const fetchRemoveBrokerRequest = (payload) => ({
  type: types.FETCH_REMOVE_BROKER_REQUEST,
  payload,
});

const fetchRemoveBrokerSuccess = (payload) => ({
  type: types.FETCH_REMOVE_BROKER_SUCCESS,
  payload,
});

const fetchRemoveBrokerFailed = (payload) => ({
  type: types.FETCH_REMOVE_BROKER_FAILED,
  payload,
});

export const fetchRemoveBroker =
  (id, broker, step = 'connection') =>
  async (dispatch) => {
    dispatch(fetchRemoveBrokerRequest());

    const response = await vehicleActions.removeBroker(id, broker);

    if (response.ok) {
      dispatch(
        uiActions.handleShowSnackbar({
          type: 'success',
          message: 'Broker removed successfully',
        })
      );
      dispatch(
        fetchRemoveBrokerSuccess({
          step,
          data: response.data,
        })
      );
      return dispatch(fetchVehicleById(id, 'onboarding'));
    }

    const formattedError = getErrorMessage(response.data);

    if (typeof formattedError === 'string') {
      dispatch(
        uiActions.handleShowSnackbar({
          type: 'error',
          message: formattedError,
        })
      );
    }

    dispatch(fetchRemoveBrokerFailed({ errors: formattedError }));
  };

export const getAvailablesServices =
  (payload, step = 'services', listName = 'availables') =>
  async (dispatch) => {
    dispatch(updateStepListsRequest({ step, listName }));

    const response = await organizationActions.fetchOrganizations(payload);

    if (response.ok) {
      return dispatch(
        updateStepListsSuccess({
          data: {
            list: response.data,
          },
          listName,
          step,
        })
      );
    }

    const formattedError = getErrorMessage(!response.ok ? response.data : response.ok);

    dispatch(updateStepListsFailed({ errors: formattedError, step, listName }));

    if (typeof formattedError === 'string') {
      return dispatch(
        uiActions.handleShowSnackbar({
          type: 'error',
          message: formattedError,
        })
      );
    }
  };

// Change service group (service group or fleet)
const changeVehicleGroupRequest = () => ({
  type: types.CHANGE_VEHICLE_GROUP_REQUEST,
});

const changeVehicleGroupSuccess = (payload) => ({
  type: types.CHANGE_VEHICLE_GROUP_SUCCESS,
  payload,
});

const changeVehicleGroupFailed = (payload) => ({
  type: types.CHANGE_VEHICLE_GROUP_FAILED,
  payload,
});

export const changeVehicleGroup = (payload, step, exit) => async (dispatch, getState) => {
  const {
    onboarding: { steps },
  } = getState().vehicles;
  dispatch(changeVehicleGroupRequest());

  let response = await vehicleActions.changeVehicleGroup(steps.details.id, payload);

  if (response.ok) {
    dispatch(
      changeVehicleGroupSuccess({
        data: response.data,
        step,
      })
    );
    return dispatch(changePosition('next', exit));
  }

  const formattedError = getErrorMessage(response.data);

  if (typeof formattedError === 'string') {
    dispatch(changeVehicleGroupFailed(formattedError));

    return dispatch(
      uiActions.handleShowSnackbar({
        type: 'error',
        message: formattedError,
      })
    );
  }

  let errors = {};

  formattedError?.length &&
    formattedError.map((val) => {
      return (errors[val.field] = val.message);
    });

  dispatch(changeVehicleGroupFailed({ errors }));
};

// Change service group (service group or fleet)
const updateVehicleGroupRequest = () => ({
  type: types.UPDATE_VEHICLE_GROUP_REQUEST,
});

const updateVehicleGroupSuccess = (payload) => ({
  type: types.UPDATE_VEHICLE_GROUP_SUCCESS,
  payload,
});

const updateVehicleGroupFailed = (payload) => ({
  type: types.UPDATE_VEHICLE_GROUP_FAILED,
  payload,
});

//TODO rename on refactor the wizard component
export const updateVehicleGroup = (vehicle_id, vehicle_group_id) => async (dispatch) => {
  dispatch(updateVehicleGroupRequest());

  let response = await vehicleActions.changeVehicleGroup(vehicle_id, {
    group_id: vehicle_group_id,
  });

  if (response.ok) {
    dispatch(
      uiActions.handleShowSnackbar({
        type: 'success',
        message: i18n.t('vehicle_groups.vehicle_edited_success_msg'),
      })
    );
    dispatch(
      updateVehicleGroupSuccess({
        data: response.data,
      })
    );
    return response;
  }

  const formattedError = getErrorMessage(response.data);

  if (typeof formattedError === 'string') {
    dispatch(updateVehicleGroupFailed(formattedError));

    dispatch(
      uiActions.handleShowSnackbar({
        type: 'error',
        message: formattedError,
      })
    );
    return response;
  }

  let errors = {};

  formattedError?.length &&
    formattedError.map((val) => {
      return (errors[val.field] = val.message);
    });

  dispatch(updateVehicleGroupFailed({ errors }));
};

const changeVehicleStatusRequest = () => ({
  type: types.CHANGE_VEHICLE_STATUS_REQUEST,
});

const changeVehicleStatusSuccess = (payload, page) => ({
  type: types.CHANGE_VEHICLE_STATUS_SUCCESS,
  payload,
  page,
});

const changeVehicleStatusFailed = (payload, page) => ({
  type: types.CHANGE_VEHICLE_STATUS_FAILED,
  payload,
  page,
});

const changeVehicleStatusConflict = (payload) => ({
  type: types.CHANGE_VEHICLE_STATUS_CONFLICT,
  payload,
});

/**
 * Change vehicle status
 * @param {object} payload Payload to change status or schedule vehicle activation.
 */
export const changeVehicleStatus =
  (payload, id, inShopManagementEnabled) => async (dispatch, getState) => {
    const {
      onboarding: { steps },
    } = getState().vehicles;
    dispatch(changeVehicleStatusRequest());

    let response = await vehicleActions.changeVehicleStatus(id || steps?.details?.id, payload);

    if (response?.ok) {
      if (id && !inShopManagementEnabled) {
        dispatch(
          uiActions.handleShowSnackbar({
            type: 'success',
            message: 'Vehicle status changed',
          })
        );
      }
      dispatch(changePosition('next', true));
      return dispatch(changeVehicleStatusSuccess(response?.data, id ? 'vehicle-details' : null));
    }

    if (
      response?.status === 400 &&
      response?.data?.key === 'RESERVATIONSEXIST' &&
      inShopManagementEnabled
    ) {
      dispatch(
        changeVehicleStatusFailed(
          { errors: { hasConflictingReservations: true } },
          id ? 'vehicle-details' : null
        )
      );
      return;
    }

    const formattedError = getErrorMessage(response?.data, {}, true);
    if (typeof formattedError === 'string') {
      if (!inShopManagementEnabled) {
        dispatch(changeVehicleStatusFailed());
        return dispatch(
          uiActions.handleShowSnackbar({
            type: 'error',
            message: formattedError,
          })
        );
      } else {
        return dispatch(
          changeVehicleStatusFailed(
            { errors: { message: formattedError } },
            id ? 'vehicle-details' : null
          )
        );
      }
    }

    let errors = {};

    formattedError?.length &&
      formattedError.map((val) => {
        return (errors[val.field] = val.message);
      });

    dispatch(changeVehicleStatusFailed({ errors }, id ? 'vehicle-details' : null));
  };
// Vehicle Actions
const setVehicleActionRequest = () => ({
  type: types.SET_VEHICLE_ACTION_REQUEST,
});

const setVehicleActionSuccess = (payload) => ({
  type: types.SET_VEHICLE_ACTION_SUCCESS,
  payload,
});

const setVehicleActionFailed = (payload) => ({
  type: types.SET_VEHICLE_ACTION_FAILED,
  payload,
});

/**
 * Change vehicle status
 * @param {object} payload Payload to change status or schedule vehicle activation.
 */
export const changeMultipleVehicleStatus =
  (payload, inShopManagementEnabled) => async (dispatch) => {
    dispatch(changeVehicleStatusRequest());

    let response = await vehicleActions.changeMultipleVehicleStatus(payload);

    if (response?.ok) {
      // Check if response data is an array (list of conflicting vehicles)
      if (inShopManagementEnabled && Array.isArray(response.data) && response.data.length > 0) {
        dispatch(changeVehicleStatusConflict({ conflictingVehicles: response.data }));
        return;
      }

      dispatch(
        uiActions.handleShowSnackbar({
          type: 'success',
          message: i18n.t(`vehicle.multiple_status_changed`),
        })
      );
      return dispatch(changeVehicleStatusSuccess(response?.data));
    }

    const formattedError = getErrorMessage(response?.data, {}, true);
    if (typeof formattedError === 'string') {
      dispatch(changeVehicleStatusFailed());
      return dispatch(
        uiActions.handleShowSnackbar({
          type: 'error',
          message: formattedError,
        })
      );
    }

    let errors = {};

    formattedError?.length &&
      formattedError.map((val) => {
        return (errors[val.field] = val.message);
      });

    dispatch(changeVehicleStatusFailed({ errors }));
  };

/**
 * Set vehicle action
 * @param {object} action Vehicle action.
 */
export const setVehicleAction = (id, action) => async (dispatch) => {
  dispatch(setVehicleActionRequest());

  let response = await vehicleActions.setVehicleAction(id, action);

  if (response?.ok) {
    let actionKey = '';
    switch (action) {
      case 'LOCK':
        actionKey = 'lock';
        break;
      case 'UNLOCK':
        actionKey = 'unlock';
        break;
      case 'IDENTIFY':
        actionKey = 'identify';
        break;
      case 'REFRESHGPS':
        actionKey = 'refresh_gps';
        break;
      case 'REFRESHDATA':
        actionKey = 'action';
        break;
      default:
        actionKey = 'unlock_enable';
    }

    dispatch(
      uiActions.handleShowSnackbar({
        type: 'success',
        message: i18n.t(`vehicle.${actionKey}_success`),
      })
    );
    return dispatch(setVehicleActionSuccess());
  }

  const formattedError = getErrorMessage(response?.data);
  dispatch(setVehicleActionFailed({ errors: formattedError }));

  if (typeof formattedError === 'string') {
    return dispatch(
      uiActions.handleShowSnackbar({
        type: 'error',
        message: formattedError,
      })
    );
  }

  dispatch(
    uiActions.handleShowSnackbar({
      type: 'error',
      message: formattedError[0].message,
    })
  );
};
/* 
  RESET CHANGE STATUS
 */
const resetChangeStatusSuccess = (payload) => ({
  type: types.RESET_CHANGE_STATUS_SUCCESS,
  payload,
});
export const resetChangeStatus = () => {
  return async (dispatch) => {
    dispatch(resetChangeStatusSuccess());
  };
};
// Set vehile profile image
const setVehicleProfileImageRequest = () => ({
  type: types.SET_VEHICLE_PROFILE_IMAGE_REQUEST,
});

const setVehicleProfileImageSuccess = (payload) => ({
  type: types.SET_VEHICLE_PROFILE_IMAGE_SUCCESS,
  payload,
});

const setVehicleProfileImageFailed = (payload) => ({
  type: types.SET_VEHICLE_PROFILE_IMAGE_FAILED,
  payload,
});
/**
 * Set vehicle profile image
 * @param {number} id Vehicle ID.
 * @param {object} payload Payload
 */
export const setVehicleProfileImage = (id, payload) => async (dispatch) => {
  dispatch(setVehicleProfileImageRequest());

  let response = await vehicleActions.setVehicleProfileImage(id, payload);

  if (response?.ok) {
    dispatch(
      uiActions.handleShowSnackbar({
        type: 'success',
        message: 'Vehicle profile image changed',
      })
    );
    return dispatch(setVehicleProfileImageSuccess(response?.data));
  }

  const formattedError = getErrorMessage(response?.data);
  dispatch(setVehicleProfileImageFailed({ errors: formattedError }));

  if (typeof formattedError === 'string') {
    return dispatch(
      uiActions.handleShowSnackbar({
        type: 'error',
        message: formattedError,
      })
    );
  }

  dispatch(
    uiActions.handleShowSnackbar({
      type: 'error',
      message: formattedError[0].message,
    })
  );
};
// Delete vehicle images
const deleteVehicleImagesRequest = () => ({
  type: types.DELETE_VEHICLE_IMAGES_REQUEST,
});

const deleteVehicleImagesSuccess = (payload) => ({
  type: types.DELETE_VEHICLE_IMAGES_SUCCESS,
  payload,
});

const deleteVehicleImagesFailed = (payload) => ({
  type: types.DELETE_VEHICLE_IMAGES_FAILED,
  payload,
});
/**
 * Delete vehicle images
 * @param {number} id Vehicle ID.
 * @param {array} images Images IDs.
 */
export const deleteVehicleImages = (id, images) => async (dispatch) => {
  dispatch(deleteVehicleImagesRequest());
  let response = await vehicleActions.deleteVehicleImages(id, images);
  if (response.status === 200 || response.status === 204) {
    dispatch(
      uiActions.handleShowSnackbar({
        type: 'success',
        message: `${images.length > 1 ? 'Images' : 'Image'} deleted successfully`,
      })
    );
    if (response?.data) {
      return dispatch(deleteVehicleImagesSuccess(response?.data));
    } else {
      dispatch(deleteVehicleImagesSuccess());
      return dispatch(fetchVehicleById(id));
    }
  }

  const formattedError = getErrorMessage(response?.data);
  dispatch(deleteVehicleImagesFailed({ errors: formattedError }));

  if (typeof formattedError === 'string') {
    return dispatch(
      uiActions.handleShowSnackbar({
        type: 'error',
        message: formattedError,
      })
    );
  }
  dispatch(
    uiActions.handleShowSnackbar({
      type: 'error',
      message: formattedError[0].message,
    })
  );
};
// Upload vehicle image
const uploadVehicleImageRequest = () => ({
  type: types.UPLOAD_VEHICLE_IMAGE_REQUEST,
});

const uploadVehicleImageSuccess = (payload) => ({
  type: types.UPLOAD_VEHICLE_IMAGE_SUCCESS,
  payload,
});

const uploadVehicleImageFailed = (payload) => ({
  type: types.UPLOAD_VEHICLE_IMAGE_FAILED,
  payload,
});
/**
 * Upload vehicle image
 * @param {number} id Vehicle ID.
 * @param {FormData} payload Form data.
 */
export const uploadVehicleImage = (id, payload) => async (dispatch) => {
  dispatch(uploadVehicleImageRequest());

  let response = await vehicleActions.uploadVehicleImage(id, payload);

  if (response.status === 200) {
    dispatch(
      uiActions.handleShowSnackbar({
        type: 'success',
        message: 'Image uploaded successfully',
      })
    );
    return dispatch(uploadVehicleImageSuccess(response?.data));
  }

  const formattedError = getErrorMessage(response?.data);
  dispatch(uploadVehicleImageFailed({ errors: formattedError }));

  if (typeof formattedError === 'string') {
    return dispatch(
      uiActions.handleShowSnackbar({
        type: 'error',
        message: formattedError,
      })
    );
  }

  dispatch(
    uiActions.handleShowSnackbar({
      type: 'error',
      message: formattedError[0].message,
    })
  );
};
// Reset upload vehicle image
const resetUploadVehicleImageSuccess = (payload) => ({
  type: types.RESET_UPLOAD_VEHICLE_IMAGE_SUCCESS,
  payload,
});

export const resetUploadVehicleImage = () => {
  return async (dispatch) => {
    dispatch(resetUploadVehicleImageSuccess());
  };
};

// Set vehicle type profile image
const setVehicleTypeProfileImageRequest = () => ({
  type: types.SET_VEHICLE_TYPE_PROFILE_IMAGE_REQUEST,
});

const setVehicleTypeProfileImageSuccess = (payload) => ({
  type: types.SET_VEHICLE_TYPE_PROFILE_IMAGE_SUCCESS,
  payload,
});

const setVehicleTypeProfileImageFailed = (payload) => ({
  type: types.SET_VEHICLE_TYPE_PROFILE_IMAGE_FAILED,
  payload,
});
/**
 * Set vehicle type profile image
 * @param {number} id Vehicle type ID.
 * @param {object} payload Payload
 */
export const setVehicleTypeProfileImage = (id, payload) => async (dispatch) => {
  dispatch(setVehicleTypeProfileImageRequest());

  let response = await vehicleActions.setVehicleTypeProfileImage(id, payload);

  if (response?.ok) {
    dispatch(
      uiActions.handleShowSnackbar({
        type: 'success',
        message: 'Vehicle type profile image changed',
      })
    );
    return dispatch(setVehicleTypeProfileImageSuccess(response?.data));
  }

  const formattedError = getErrorMessage(response?.data);
  dispatch(setVehicleTypeProfileImageFailed({ errors: formattedError }));

  if (typeof formattedError === 'string') {
    return dispatch(
      uiActions.handleShowSnackbar({
        type: 'error',
        message: formattedError,
      })
    );
  }

  dispatch(
    uiActions.handleShowSnackbar({
      type: 'error',
      message: formattedError[0].message,
    })
  );
};

// Delete vehicle type images
const deleteVehicleTypeImagesRequest = () => ({
  type: types.DELETE_VEHICLE_TYPE_IMAGES_REQUEST,
});

const deleteVehicleTypeImagesSuccess = (payload) => ({
  type: types.DELETE_VEHICLE_TYPE_IMAGES_SUCCESS,
  payload,
});

const deleteVehicleTypeImagesFailed = (payload) => ({
  type: types.DELETE_VEHICLE_TYPE_IMAGES_FAILED,
  payload,
});
/**
 * Delete vehicle type images
 * @param {number} id Vehicle type ID.
 * @param {array} images Images IDs.
 */
export const deleteVehicleTypeImages = (id, images) => async (dispatch) => {
  dispatch(deleteVehicleTypeImagesRequest());

  let response = await vehicleActions.deleteVehicleTypeImages(id, images);

  if (response.status === 200 || response.status === 204) {
    dispatch(
      uiActions.handleShowSnackbar({
        type: 'success',
        message: `${images.length > 1 ? 'Images' : 'Image'} deleted successfully`,
      })
    );
    if (response?.data) {
      return dispatch(deleteVehicleTypeImagesSuccess(response?.data));
    } else {
      dispatch(deleteVehicleTypeImagesSuccess());
      return dispatch(fetchVehicleTypeById(id));
    }
  }

  const formattedError = getErrorMessage(response?.data);
  dispatch(deleteVehicleTypeImagesFailed({ errors: formattedError }));

  if (typeof formattedError === 'string') {
    return dispatch(
      uiActions.handleShowSnackbar({
        type: 'error',
        message: formattedError,
      })
    );
  }

  dispatch(
    uiActions.handleShowSnackbar({
      type: 'error',
      message: formattedError[0].message,
    })
  );
};
// Upload vehicle type image
const uploadVehicleTypeImageRequest = () => ({
  type: types.UPLOAD_VEHICLE_TYPE_IMAGE_REQUEST,
});

const uploadVehicleTypeImageSuccess = (payload) => ({
  type: types.UPLOAD_VEHICLE_TYPE_IMAGE_SUCCESS,
  payload,
});

const uploadVehicleTypeImageFailed = (payload) => ({
  type: types.UPLOAD_VEHICLE_TYPE_IMAGE_FAILED,
  payload,
});
/**
 * Upload vehicle type image
 * @param {number} id Vehicle type ID.
 * @param {FormData} payload Form data.
 */
export const uploadVehicleTypeImage = (id, payload) => async (dispatch) => {
  dispatch(uploadVehicleTypeImageRequest());

  let response = await vehicleActions.uploadVehicleTypeImage(id, payload);

  if (response.status === 200) {
    dispatch(
      uiActions.handleShowSnackbar({
        type: 'success',
        message: 'Image uploaded successfully',
      })
    );
    return dispatch(uploadVehicleTypeImageSuccess(response?.data));
  }

  const formattedError = getErrorMessage(response?.data);
  dispatch(uploadVehicleTypeImageFailed({ errors: formattedError }));

  if (typeof formattedError === 'string') {
    return dispatch(
      uiActions.handleShowSnackbar({
        type: 'error',
        message: formattedError,
      })
    );
  }

  dispatch(
    uiActions.handleShowSnackbar({
      type: 'error',
      message: formattedError[0].message,
    })
  );
};

// Reset upload vehicle type image
const resetUploadVehicleTypeImageSuccess = (payload) => ({
  type: types.RESET_UPLOAD_VEHICLE_TYPE_IMAGE_SUCCESS,
  payload,
});

export const resetUploadVehicleTypeImage = () => {
  return async (dispatch) => {
    dispatch(resetUploadVehicleTypeImageSuccess());
  };
};

// Get availables brokers
const fetchAvailablesBrokersRequest = () => ({
  type: types.FETCH_AVAILABLES_BROKERS_REQUEST,
});

const fetchAvailablesBrokersSuccess = (payload) => ({
  type: types.FETCH_AVAILABLES_BROKERS_SUCCESS,
  payload,
});

const fetchAvailablesBrokersFailed = (payload) => ({
  type: types.FETCH_AVAILABLES_BROKERS_FAILED,
  payload,
});

/**
 * Fetch availables brokers
 * @param {FormData} payload Form data.
 */
export const fetchAvailablesBrokers = (step) => async (dispatch) => {
  dispatch(fetchAvailablesBrokersRequest());

  const response = await vehicleActions.getAvailablesVehicleBrokers();

  if (response.ok) {
    return dispatch(
      fetchAvailablesBrokersSuccess({
        step,
        data: response.data,
      })
    );
  }

  const formattedError = getErrorMessage(response?.data);

  dispatch(fetchAvailablesBrokersFailed({ errors: formattedError }));

  if (typeof formattedError === 'string') {
    return dispatch(
      uiActions.handleShowSnackbar({
        type: 'error',
        message: formattedError,
      })
    );
  }

  dispatch(
    uiActions.handleShowSnackbar({
      type: 'error',
      message: formattedError[0].message,
    })
  );
};

const fetchBulkUploadRequest = () => ({
  type: types.FETCH_BULK_UPLOAD_REQUEST,
});

const fetchBulkUploadSuccess = (payload) => ({
  type: types.FETCH_BULK_UPLOAD_SUCCESS,
  payload,
});

const fetchBulkUploadFailed = (payload) => ({
  type: types.FETCH_BULK_UPLOAD_FAILED,
  payload,
});

export const resetBulkUpload = () => (dispatch) => dispatch({ type: types.RESET_BULK_UPLOAD });

/**
 * Set vehicle type profile image
 * @param {object} payload Payload
 */
export const fetchBulkUpload = (payload) => async (dispatch) => {
  dispatch(fetchBulkUploadRequest());

  let response = await vehicleActions.bulkUpload(payload);

  if (response?.ok) {
    dispatch(
      uiActions.handleShowSnackbar({
        type: 'success',
        message: i18n.t('vehicle.import_csv.success_import'),
      })
    );
    return dispatch(fetchBulkUploadSuccess(response?.data));
  }

  const formattedError = getErrorMessage(response?.data);
  dispatch(fetchBulkUploadFailed({ errors: formattedError }));

  if (typeof formattedError === 'string') {
    return dispatch(
      uiActions.handleShowSnackbar({
        type: 'error',
        message: formattedError,
      })
    );
  }
};

const fetchBulkSharingRequest = () => ({
  type: types.FETCH_BULK_SHARING_REQUEST,
});

const fetchBulkSharingSuccess = (payload) => ({
  type: types.FETCH_BULK_SHARING_SUCCESS,
  payload,
});

const fetchBulkSharingFailed = (payload) => ({
  type: types.FETCH_BULK_SHARING_FAILED,
  payload,
});

/**
 * Set vehicle type profile image
 * @param {object} payload Payload
 */
export const fetchBulkSharing = (payload) => async (dispatch) => {
  dispatch(fetchBulkSharingRequest());

  let response = await vehicleActions.bulkServiceSharing(payload);

  if (response?.ok) {
    dispatch(
      uiActions.handleShowSnackbar({
        type: 'success',
        message: i18n.t('vehicle.multiple_update_sharing_changed'),
      })
    );
    return dispatch(fetchBulkSharingSuccess(response?.data));
  }

  const formattedError = getErrorMessage(response?.data);
  dispatch(fetchBulkSharingFailed({ errors: formattedError }));

  if (typeof formattedError === 'string') {
    return dispatch(
      uiActions.handleShowSnackbar({
        type: 'error',
        message: formattedError,
      })
    );
  }

  dispatch(
    uiActions.handleShowSnackbar({
      type: 'error',
      message: formattedError[0].message,
    })
  );
};

export const resetUpdateSharing = () => (dispatch) =>
  dispatch({ type: types.RESET_UPDATE_SHARING });

const fetchBulkUnshareRequest = () => ({
  type: types.FETCH_BULK_UNSHARE_REQUEST,
});

const fetchBulkUnshareSuccess = (payload) => ({
  type: types.FETCH_BULK_UNSHARE_SUCCESS,
  payload,
});

const fetchBulkUnshareFailed = (payload) => ({
  type: types.FETCH_BULK_UNSHARE_FAILED,
  payload,
});

/**
 * Set vehicle type profile image
 * @param {object} payload Payload
 */
export const fetchBulkUnshare = (payload) => async (dispatch) => {
  dispatch(fetchBulkUnshareRequest());

  const response = await vehicleActions.bulkUnshareService(payload);
  if ([200, 204].includes(response.status)) {
    dispatch(
      uiActions.handleShowSnackbar({
        type: 'success',
        message: i18n.t('vehicle.multiple_update_sharing_changed'),
      })
    );
    return dispatch(fetchBulkUnshareSuccess(response?.data));
  }

  const formattedError = getErrorMessage(response?.data);
  dispatch(fetchBulkUnshareFailed({ errors: formattedError }));

  if (typeof formattedError === 'string') {
    return dispatch(
      uiActions.handleShowSnackbar({
        type: 'error',
        message: formattedError,
      })
    );
  }
  dispatch(
    uiActions.handleShowSnackbar({
      type: 'error',
      message: formattedError[0].message,
    })
  );
};

export const resetBulkUnshare = () => (dispatch) => dispatch({ type: types.RESET_UPDATE_SHARING });
// Get vehicle statuses by ID
const fetchVehicleStatusesByIdRequest = () => ({
  type: types.FETCH_VEHICLE_STATUSES_BY_ID_REQUEST,
});

const fetchVehicleStatusesByIdSuccess = (payload) => ({
  type: types.FETCH_VEHICLE_STATUSES_BY_ID_SUCCESS,
  payload,
});

const fetchVehicleStatusesByIdFailed = () => ({
  type: types.FETCH_VEHICLE_STATUSES_BY_ID_FAILED,
});

export const fetchVehicleStatusesById = (id, params) => {
  return async (dispatch) => {
    params = removeEmpty(params);
    dispatch(fetchVehicleStatusesByIdRequest());
    const response = await vehicleActions.fetchVehicleStatusesById(id, params);
    if (response.ok) {
      const pagination = parsePagination(response.headers);
      return dispatch(
        fetchVehicleStatusesByIdSuccess({
          pagination: pagination,
          data: response.data,
        })
      );
    }
    const error = getErrorMessage(response.data);
    dispatch(
      uiActions.handleShowSnackbar({
        type: 'error',
        message: error,
      })
    );
    dispatch(fetchVehicleStatusesByIdFailed(error));
  };
};

// Get Broker Settings
const fetchGetBrokerSettingsRequest = (payload) => ({
  type: types.FETCH_GET_BROKER_SETTINGS_REQUEST,
  payload,
});

const fetchGetBrokerSettingsSuccess = (payload) => ({
  type: types.FETCH_GET_BROKER_SETTINGS_SUCCESS,
  payload,
});

const fetchGetBrokerSettingsFailed = (payload) => ({
  type: types.FETCH_GET_BROKER_SETTINGS_FAILED,
  payload,
});

export const fetchGetBrokerSettings = (id, broker) => {
  return async (dispatch) => {
    dispatch(fetchGetBrokerSettingsRequest());

    const response = await vehicleActions.getBrokerSettings(id, broker);

    if (response.ok) {
      return dispatch(
        fetchGetBrokerSettingsSuccess({
          data: response.data,
        })
      );
    }

    const error = getErrorMessage(response.data);

    dispatch(
      uiActions.handleShowSnackbar({
        type: 'error',
        message: error,
      })
    );

    dispatch(fetchGetBrokerSettingsFailed(error));
  };
};

// Put Broker Settings
const fetchUpdateBrokerSettingsRequest = (payload) => ({
  type: types.FETCH_UPDATE_BROKER_SETTINGS_REQUEST,
  payload,
});

const fetchUpdateBrokerSettingsSuccess = (payload) => ({
  type: types.FETCH_UPDATE_BROKER_SETTINGS_SUCCESS,
  payload,
});

const fetchUpdateBrokerSettingsFailed = (payload) => ({
  type: types.FETCH_UPDATE_BROKER_SETTINGS_FAILED,
  payload,
});

const resetUpdateBrokerSettingsSuccess = (payload) => ({
  type: types.RESET_UPDATE_BROKER_SETTING_SUCCESS,
  payload,
});

export const fetchUpdateBrokerSettings = (id, broker, payload) => async (dispatch) => {
  dispatch(fetchUpdateBrokerSettingsRequest());

  const response = await vehicleActions.putBrokerSettings(id, broker, payload);

  if (response.ok) {
    dispatch(
      uiActions.handleShowSnackbar({
        type: 'success',
        message: 'Broker updated successfully',
      })
    );
    return dispatch(
      fetchUpdateBrokerSettingsSuccess({
        data: response.data,
      })
    );
  }

  const formattedError = getErrorMessage(response.data);

  if (typeof formattedError === 'string') {
    dispatch(
      uiActions.handleShowSnackbar({
        type: 'error',
        message: formattedError,
      })
    );
  }

  dispatch(fetchUpdateBrokerSettingsFailed({ errors: formattedError }));
};

export const resetUpdateBrokerSettings = () => async (dispatch) => {
  dispatch(resetUpdateBrokerSettingsSuccess());
};

export const resetVehicle = () => (dispatch) =>
  dispatch({
    type: types.RESET_VEHICLE,
  });
